import * as actionTypes from '../constants/actionTypes';

import {
  CheckerForSmsUser,
  InitializeUpdateForRelatedUsers,
  RemainderNotificationResponse,
  RemainderNotificationUser,
  SmsUpdatesResponse,
  UnreadMessageResponse,
  UnreadMessageUser,
} from '../../models';

export const setRemainderNotificationMessage = (message: RemainderNotificationResponse) => {
  return {
    type: actionTypes.WEB_SOCKET_SET_REMAINDER_NOTIFICATION_MESSAGE,
    data: message,
  };
};

export const setUnreadMessage = (message: UnreadMessageResponse) => {
  return {
    type: actionTypes.WEB_SOCKET_SET_UNREAD_MESSAGE,
    data: message,
  };
};

export const setSmsMessage = (message: SmsUpdatesResponse) => {
  return {
    type: actionTypes.WEB_SOCKET_SET_SMS_MESSAGE,
    data: message,
  };
};

export const sendMessage = (message: RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers) => {
  return {
    type: actionTypes.WEB_SOCKET_SEND_MESSAGE,
    data: message,
  };
};

export const clearBufferOfMessageToSend = () => {
  return {
    type: actionTypes.WEB_SOCKET_CLEAR_BUFFER_OF_MESSAGE_TO_SEND,
    data: [],
  };
};

export const addMessageToBuffer = (message: RemainderNotificationUser | CheckerForSmsUser | UnreadMessageUser | InitializeUpdateForRelatedUsers) => {
  return {
    type: actionTypes.WEB_SOCKET_ADD_MESSAGE_TO_BUFFER,
    data: message,
  };
};
